import type { WorkflowOptions } from '../../types';
import { addCarrierRateSetWorkflow } from './addCarrierRateSetWorkflow';
import { editCarrierRateSetWorkflow } from './editCarrierRateSetWorkflow';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
export const workflows: WorkflowOptions[] = [
  addCarrierRateSetWorkflow,
  editCarrierRateSetWorkflow,
  ...Object.values(generateAssetStatusWorkflow('carrierRateSet')),
];

export default workflows;
